module.exports = __webpack_public_path__ + "static/media/Picture1.25d7d44e.jpg";